import { Component, OnInit } from '@angular/core';
import { BoletoService } from 'src/app/services/convenio/boleto.service';
import { CorteService } from 'src/app/services/corte.service';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { Boleto } from 'src/app/models';
import * as moment from 'moment';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { addVehiculoExe } from 'src/app/state/actions/btnRapido.actions';
import { ExentosService } from 'src/app/services/exentos.service';
import { selectCruce } from 'src/app/state/selectors/cruce.selectors';
import { selectBtnRapido } from 'src/app/state/selectors/btnRapido.selectors';
import { ResidentesService } from 'src/app/services/residentes.service';
@Component({
  selector: 'app-scan-exe',
  templateUrl: './scan-exe.component.html',
  styleUrls: ['./scan-exe.component.scss']
})
export class ScanExeComponent implements OnInit {
  
  scanCode
  codigoQR = ''
  actualUser: any;
  baseVehiculosExe: any;
  formulario: any;
  color = '';
  cruce: any = null;
  confirmarRegistro: boolean = false;
  confirmarAnotacionCajero: boolean = false;
  falloLectura : any; //guarda el fallo al leer
  exentoAlRegistro: any; //para mandarl al fallo  
  numeroRandom: any; //numero para mostrar al cobrardor y registrar

  constructor(
    private boletoService: BoletoService,
    private ngxServiceLoader: NgxUiLoaderService,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private router: Router,
    private corteService: CorteService,
    private exeService: ExentosService,
    private resService: ResidentesService
  ) {

  }

  ngOnInit(): void {
    this.store.select(selectUser).subscribe(user => {
      this.actualUser = user;
      console.log(this.actualUser);

    })

    this.store.select(selectBtnRapido).subscribe(cruce => this.cruce = cruce);
    console.log(this.cruce);
    console.log(this.cruce);

  }

  onChangeTN(e: number) {
    console.log(e);
    this.scanCode = e;
  }

  validateScanCode(e) {
    // [
    //   {"id":"61","nombre":"RPI 50%"},
    //   {"id":"62","nombre":"EXE 100%"},
    //   {"id":"76","nombre":"RESIDENTES"},
    //   {"id":"77","nombre":"GES"}
    //   ]
    this.busquedaTarjeton(e, this.cruce.id_subtipo)

  }

  busquedaTarjeton(tarjeton_leido,cruce) {
    this.falloLectura = null;
    this.ngxServiceLoader.start();
    this.resService.buscarPadronPorTarjeta(tarjeton_leido)
      .then(tarjeton => {
        console.log(tarjeton);
        this.ngxServiceLoader.stop();
        if (this.cruce.id_subtipo != tarjeton.data[0].id_tipo_pase) {
          return this.toastr.error('Tarjeton distinto', 'Revise el tipo del tarjeton', { positionClass: 'toast-bottom-right' })
        }
        if (!tarjeton.data) {
          this.falloLectura = tarjeton_leido;
          this.confirmarRegistro = true;
          return this.toastr.error('Tarjeton no encontrado', 'Revise el numero del tarjeton', { positionClass: 'toast-bottom-right' })
        }
        //validar si es valido o no el tarjeton
        if (!tarjeton.data[0].estatus) {
          return this.toastr.error('Tarjeton invalido', '', { positionClass: 'toast-bottom-right' })
        }
        this.baseVehiculosExe = tarjeton.data[0]
        //this.setFormulario(tarjeton)
        // this.baseVehiculosExe = tarjetones.data;
        // console.log(tarjetones.data)
      }).catch(error => {
        console.log(error);
        this.falloLectura = tarjeton_leido;
        this.confirmarRegistro = true;
        this.ngxServiceLoader.stop();
        return this.toastr.error(`Por favor intenta de nuevo, ${error.error.message}`, 'Error', { positionClass: 'toast-bottom-right' })
      })
  }
  

  saveScanCode(vehiculo_preregistro? : any) {
    //guardar en redux
    let id_vehiculo = null;
    if(vehiculo_preregistro){
      id_vehiculo = vehiculo_preregistro.id
    }else{
      id_vehiculo = this.baseVehiculosExe.id
    }
    console.log(this.baseVehiculosExe);
    console.log(id_vehiculo);
    this.store.dispatch(addVehiculoExe({ id_vehiculo_exe: id_vehiculo }))
    this.toastr.info('', 'Selecione la clasificacion vehicular', { positionClass: 'toast-bottom-right' })
    //Redireccionar
    this.router.navigate(['/mopa/clasificacion-vehicular']);

  }

  cancelAction() {
    this.router.navigate(['/mopa/home']);
  }


  /*
  Revisa que el codigo QR exista y este diponible
  para cruce
   */
  validateQR() {

    let tarjeton = this.codigoQR.split(".")
    console.log(tarjeton);
    this.busquedaTarjeton(tarjeton[0],tarjeton[1])
  }

  recibiRespuesta(respuesta) {
    //eliminar datos del formulario
    this.formulario = null
    console.log(respuesta);

    this.codigoQR = respuesta;
    //quitar **
    //var lec = respuesta.split('**')
    //validar codigo qr
    this.validateQR()

  }

  setFormulario(result) {// no used
    console.log(this.formulario);
    this.formulario = result[0];

    this.color = this.getColorTicket(this.formulario?.tipo_pase)
  }

  validateBoleto(numero) {//no used
    //obtener info boleto
    var result;
    result = this.baseVehiculosExe.filter(b => b.no_tarjeton == numero);
    //validar si existe el boleto en la bd local y no este activo
    let index = this.baseVehiculosExe.findIndex(m => m.no_tarjeton == numero && m.estatus == 1);
    if (index === -1) {//no encontrado
      this.toastr.error('No se encontro el boleto', 'Revisa el codigo', { positionClass: 'toast-bottom-right' });
      this.formulario = null;
    } else
      //setear formulario
      this.setFormulario(result);
  }

  getColorTicket(id_clasificacion: any) {//no used
    switch (id_clasificacion) {
      case 1://moto
        return "blue";
        break;
      case 2://auto
        return "hotpink";
        break;
      case 3:// auto con remolque
        return "darkviolet";
        break;
      case 4://Bus 2
        return "#E74C3C";
        break;
      case 5://B3
        return "saddlebrown";
        break;
      case 6://B4
        return "darkgreen";
        break;
      case 7://C2
        return "#E74C3C ";
        break;
      case 8://C3
        return "saddlebrown";
        break;
      case 9://C4
        return "darkgreen";
        break;
      case 10://C5
        return "darkorange";
        break;
      case 11://C6
        return "#000";
        break;
      case 12://C7
        return "darkviolet";
        break;
      case 13://C8
        return "green";
        break;
      case 14://C9
        return "darkcyan";
        break;
      case 15://EEC
        return "orange";
        break;
      default: return "#fff";
    }
  }

  async mandarRegistro(){
    this.ngxServiceLoader.start();
    console.log(this.falloLectura);
    this.numeroRandom = this.genValorRegistro(this.falloLectura);
    let dataNuevoPadron = this.generarRegistroPadron(this.falloLectura,this.cruce.id_subtipo);
    const respuesta = await this.resService.crearPadron(dataNuevoPadron);
    this.ngxServiceLoader.stop();
    if (respuesta && respuesta.success){
      let dataNuevoRegistro = this.generarPreRegistro(this.numeroRandom.toString(),this.falloLectura,respuesta.data.id);
      const response = await this.resService.crearPreRegistro(dataNuevoRegistro);
      if (response && response.success){
        this.exentoAlRegistro = respuesta.data;
        this.toastr.info('Enviado a Preregistro');
        this.confirmarRegistro = false;
        this.confirmarAnotacionCajero = true;

      }
    }
  }

  finalizarRegistro(){
    this.saveScanCode(this.exentoAlRegistro);
    this.confirmarAnotacionCajero = false;
    this.falloLectura = null;
  }

  cancelarRegistro(){
    this.confirmarRegistro = false;
  }

  genValorRegistro (numero_leido: any) {
    let valorRandom = Math.floor(1000 + Math.random() * 9000);
    console.log(numero_leido);
    let substr = numero_leido.toString().slice(-4);
    return valorRandom + substr;
  }

  generarRegistroPadron(lectura_tarjeta : string, tipo_de_pase : number){
    return {
      no_tarjeta: lectura_tarjeta,
      id_tipo_pase: tipo_de_pase,
      id_persona: (tipo_de_pase == 61)? null : 1, // Es preregistro no lleva id
      estatus: 1, 
      fecha_registro: new Date().toISOString().split('T')[0], 
    };
  }

  generarPreRegistro(numero_aleatorio : string, lectura_tarjeta : string, numero_padron : number){
    return {
      rand_registro: numero_aleatorio,
      id_padron: numero_padron,
      no_tarjeta: lectura_tarjeta,
      fecha: new Date().toISOString().split('T')[0],
      procesado: 0,
    }
  }
}
